import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '../api/appsync-client.js'

const TEAM_FEED = `
  query TeamFeed {
    teamFeed {
      sessionId userId managerId status energy scheduledAt
      createdAt updatedAt
    }
  }
`

export function useTeamFeed({ enabled = true } = {}) {
  const [sessions, setSessions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await appsyncQuery(TEAM_FEED)
      setSessions(data.teamFeed || [])
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { if (enabled) load() }, [load, enabled])

  useEffect(() => {
    if (!enabled) return
    const handler = () => { if (document.visibilityState === 'visible') load() }
    document.addEventListener('visibilitychange', handler)
    return () => document.removeEventListener('visibilitychange', handler)
  }, [enabled, load])

  return { feedSessions: sessions, loading, error, reload: load }
}
